export default __webpack_public_path__ + "static/media/hospital.875adf5d.svg";